export const ACCOUNT_CREATION = {
	SET_THERAPIES: 'ACCOUNT_CREATION_SET_THERAPIES',
	FINALIZE_ACCOUNT_SETUP: 'ACCOUNT_CREATION_FINALIZE_ACCOUNT_SETUP',
	GET_ALL_TIMEZONES: 'ACCOUNT_CREATION_GET_ALL_TIMEZONES',
	SET_ALL_TIMEZONES: 'ACCOUNT_CREATION_SET_ALL_TIMEZONES',
};
